import { useKeycloak } from '@react-keycloak/web'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function Login() {
  const { keycloak } = useKeycloak()
  const history = useHistory()

  useEffect(() => {
    if (keycloak.authenticated) {
      history.push('/nav')
    } else {
      keycloak.login()
    }
  }, [keycloak])

  return <div />
}

export default Login
